module.exports = __webpack_public_path__ + "static/img/2.361aa8fe.png";